
import React, {FC} from 'react';

import * as styles from './styles.module.scss';

const InfoText: FC<{children: string}> = ({children}) => {
	return (
		<div className={styles.infoText}>
			<div>{children}</div>
		</div>
	);
};

const SeeData = () => {
	return (
		<InfoText>
			See the power of your data first-hand.
			Credits never expire and can be transferred
			to friends & family.
		</InfoText>
	);
};

const NoStrings = () => {
	return (
		<InfoText>
			No strings attached-cancel anytime.
			Credits never expire and can be
			transferred to friends & family.
		</InfoText>
	);
};

const Custom = () => {
	return (
		<InfoText>
			No strings attached-credits never
			expire and can be transferred to
			friends & family.
		</InfoText>
	);
};

export default {
	Custom,
	NoStrings,
	SeeData,
};
